module.exports = __webpack_public_path__ + "img/tyy_tbt894-1999.prt.fc555a2c.jpg";